import util from '../../lib/util';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from "../find";
import Participant from '../../entities/participant';
import Event from '../../entities/event';

/*
 * Delete/nullify anywhere this participant is used in other entities
 *
 * @param {Participant} participant
 */
export function deleteParticipant(participant: Participant, mergeId?: string) {
    let targetImportSource = 'merge';

    if (!mergeId) {
        targetImportSource = 'delete';
        mergeId = participant.id;
    }
    /* Simple delete usages */
        
    store.getState().events
        .getMappingFor('participantId', participant.id)
        .filter(eventTemp => eventTemp.status !== 'D')
        .forEach(eventTemp => {
            const _event = eventTemp.clone();
            _event.status =  'U';
            _event.addedOn = newHRTimestamp();
            _event.importSource = targetImportSource;
            _event.importId = mergeId;

            _event.participants = _event.participants?.filter(id => id !== participant.id) || [];
            store.dispatch(Actions.EventActions.saveEventQueue(_event));
        });

    /* Remove the actual participant */
    participant.status = 'D';
    participant.addedOn = newHRTimestamp();
    participant.addedBy = getCurrentUserId();
    participant.importSource = targetImportSource;
    participant.importId = mergeId;
    store.dispatch(Actions.ParticipantActions.removeParticipantQueue(participant));
    
}

/*
 * Replace anywhere this participant is used in other entities.
 *
 * @param {Participant} participant
 * @param {Participant} replaceWith
 * @return {Participant} - Participant will have refs stripped away
 */
export function replaceParticipant(participant: Participant, replaceWith: Participant, mergeId?: string) {
    let targetImportSource = 'merge';

    if (!mergeId) {
        targetImportSource = 'delete';
        mergeId = participant.id;
    }
    /* Simple replace usages */
        
    store.getState().events
        .getMappingFor('participantId', participant.id)
        .filter(eventTemp => eventTemp.status !== 'D')
        .forEach(eventTemp => {
            const _event = eventTemp.clone();
            _event.status =  'U';
            _event.addedOn = newHRTimestamp();
            _event.importSource = targetImportSource;
            _event.importId = mergeId;

            _event.participants = _event.participants?.map(id => (id === participant.id) ? replaceWith.id : id) || [];
            store.dispatch(Actions.EventActions.saveEventQueue(_event));
        });

    return participant;
}

/*
 * Determine the impact of deleting this participant from other entities
 *
 * @param {Participant} participant
 * @return {Array.<{count: number, entity: string}>} - a list of impacted entities, along with a count of impacted entities
 */
export function deleteImpactParticipant(participant: Participant) {
    const impacts: string[] = [];
    const state = store.getState();
    
    /* Simple delete usages */
        
    const eventParticipantsImpact = state.events
          .getMappingFor('participantId', participant.id)
          .filter(event => event.status !== 'D');

    eventParticipantsImpact.forEach(() => impacts.push('events'));

    return util.countDistinct(impacts);
}